import React, { useState, useEffect } from "react";
import InputMask from 'react-input-mask';
import { fetcherPOSTJSON } from "../Common/Fetch";
import { Field } from "../Types/Form";
import useDataStore from "../Hooks/useDataStore";
import Input from "../FormUi/Input";
import usePostTelegramBot from "../Api/usePostTelegramBot";
import Popup from "../Popups/Popup";
import Loading from "../Ui/Loading";


//test
//https://api.telegram.org/bot7229815824:AAFd3AGDotsDsiuoU3qzJl6ezXk6WRVeF9w/sendMessage
//-4685858033

//const params = {
//    chat_id: -4166037569,
//    text: `URL: ${document.URL}\n\n Имя: ${name}\n Номер телефона: ${phone}\n Комментарий: ${message}`,
//};https://api.telegram.org/bot7649938106:AAGCziBiX53uAgJx6Va84EbzX6z5MrV-Zt4/sendMessage
function ContactForm() {
    const [fields, setFields] = useState<Field[]>([
        { name: "Name", title: "Ваше имя*", require: true },
        { name: "Comment", title: "Комментарий", element: "textarea" },
        { name: "phone", title: "Телефон*", require: true },
        {
            name: "Agreement",
            element: "checkbox",
            title: "Я прочитал(а) и согласен(на) с",
            link: { linkName: "Политикой обработки персональных данных", url: "https://realty.viomitra.ru/conf1" },
            require: true
        }
    ])

    const [isOpen, setIsOpen] = useState(false);
    const { mutate, isPending, isSuccess, isError } = usePostTelegramBot();
    const { getData, values, errors, handleChange } = useDataStore({ fields: fields });

    const send = (data) => {
        const dataToSend = Object.keys(data).map(key => {
            return { [String(fields.find(item => item.name == key).title)]: data[key] }
        })

        let resultText = dataToSend
            .map(item => {
                const key = Object.keys(item)[0];
                const value = item[key];
                return `${key}: ${value}`;
            })
            .join('\n');

        mutate({ text: resultText, chat_id: -4166037569, url: "https://api.telegram.org/bot7649938106:AAGCziBiX53uAgJx6Va84EbzX6z5MrV-Zt4/sendMessage" })
    }

    useEffect(() => {
        setIsOpen(isSuccess || isError);
    }, [isSuccess, isError])

    return (
        <>
            {isPending && <Loading />}
            <div className="contactForm">
                {fields.map(i =>
                    <Input
                        field={i}
                        value={values?.[i.name]}
                        error={errors?.[i.name]}
                        onChange={handleChange}
                    />
                )}
                <button
                    onClick={() => getData(send)}
                >Отправить данные</button>
            </div>

            <Popup
                isOpen={isOpen}
                head={isSuccess ? { title: "Сообщение успешно отправлено" } : { title: "Произошла ошибка.." }}
                close={() => setIsOpen(false)}
            />
        </>
    );
}

export default ContactForm;